import { RouteItem } from '@eastcoal/router/types/route'

import { DEPT_ACTION_UUID, ORGANIZATION_PAGE, USER_ACTION_UUID } from './uuid'

export const organizationRoute: RouteItem = {
  title: '组织架构',
  path: '/organization',
  uuid: ORGANIZATION_PAGE,
  Component: () => import('./index'),
  hideChildrenInMenu: true,
  children: [
    {
      title: '管理部门',
      uuid: DEPT_ACTION_UUID
    },
    {
      title: '管理用户',
      uuid: USER_ACTION_UUID
    }
  ]
}
